import { ITheme } from "../../utils/theme"

export const SelectContainerStyle = {
  justifyContent: "center"
}

export const SelectStyle = {
  width: '100%',
  m: { xs: "8px 2px", sm: 1 },
  "&.MuiOutlinedInput-root": {
    "& .MuiSelect-select": {
      minHeight: { xs: "45px", sm: "1.4375em" },
      whiteSpace: { xs: "pre-wrap", sm: "nowrap" },
      p: { xs: "5px 15px", sm: "16.5px 14px" },
      display: "flex",
      justifyContent: "center",
      alignItems: "center",      
    }
  }
}

export const SelectMenuStyle = {
  maxHeight: { xs: 300, sm: 400, md: 500 }
}

export const PlaceholderStyle = {
  color: (theme: ITheme) => theme.palette.grey[400]
}

export const ViewMyPlateStyle = {
  fontWeight: "bold",
  textDecoration: "underline",
  color: 'black',
  ml: { xs: '16px', sm: '-44px' },
  mt: 1,
  textTransform: 'initial',
}

export const ReviewBtnStyle = {
  position: 'absolute',
  right: '16px',
  bottom: '25px',
}

export const SlipsHeaderStyle = {
  color: 'white',
  background: (theme: ITheme) => theme.palette.blue[900],
  textAlign: 'left',
  p: 0.5,
  mb: 1,
}

export const TooltipStyle = {
  color: 'black',
  background: 'white',
  border: '1px solid black',
  borderRadius: 0,
  '& .MuiTooltip-popper[data-popper-placement*="top"] .MuiTooltip-tooltip': {
    m: 0
  }
}